document.querySelectorAll('a[target="_blank"]').forEach((link) => {
  // This works because we set the data-external-link-space
  // BEFORE foundation is initialized. That is solve most of the cases,
  // as Jquery and Foundation are both slow to run.
  link.setAttribute("data-external-link-spacer", "");
});
